import openModal from 'App/services/Modal';
angular.module('domain.admin').controller('AdminSubCtrl', [
	'$safeApply',
	'AppService',
	'FeatureHelper',
	'$stateParams',
	'$state',
	'URL',
	'$scope',
	'StandardField',
	'Self',
	'ActivityType',
	'AppointmentType',
	'$q',
	'$upModal',
	'$translate',
	'CustomField',
	'OrderStage',
	'ClientParam',
	'ListViewService',
	'User',
	'Import',
	'WhatIsMyIp',
	'RequestBuilder',
	'DocumentTemplate',
	'TagService',
	'CacheRefresher',
	'Product',
	'API',
	'File',
	'UserDefinedDefinition',
	'Order',
	'Agreement',
	'ProductCategory',
	'ContactAttributes',
	'ActivityAttributes',
	'AppointmentAttributes',
	'OrderAttributes',
	'OpportunityAttributes',
	'MailAttributes',
	'MultiActions',
	'NotificationService',
	function (
		$safeApply,
		AppService,
		FeatureHelper,
		$stateParams,
		$state,
		URL,
		$scope,
		StandardField,
		Self,
		ActivityType,
		AppointmentType,
		$q,
		$upModal,
		$translate,
		CustomField,
		OrderStage,
		ClientParam,
		ListViewService,
		User,
		Import,
		WhatIsMyIp,
		RequestBuilder,
		DocumentTemplate,
		TagService,
		CacheRefresher,
		Product,
		API,
		File,
		UserDefinedDefinition,
		Order,
		Agreement,
		ProductCategory,
		ContactAttributes,
		ActivityAttributes,
		AppointmentAttributes,
		OrderAttributes,
		OpportunityAttributes,
		MailAttributes,
		MultiActions,
		NotificationService
	) {
		var AdminSubCtrl = this;
		var AdminCtrl = $scope.AdminCtrl;

		AdminSubCtrl.rootData = AdminCtrl.getRootObject();

		var init = function () {
			var component;
			var useWebPack = false;

			switch ($state.current.name) {
				case 'administration.imports':
					component = 'imports';

					AdminSubCtrl.rootData.pageLoading = true;

					AdminSubCtrl.rootData.pageData = {
						doneLoading: false,
						doneTotal: 0,
						doneOffset: 0,
						done: [],
						ongoingLoading: false,
						ongoingTotal: 0,
						ongoingOffset: 0,
						ongoing: [],
						draftLoading: false,
						draftTotal: 0,
						draftOffset: 0,
						draft: [],
						startedLoading: false,
						startedTotal: 0,
						startedOffset: 0,
						started: [],
						limit: 50
					};

					var getImports = function (status, offset) {
						var importFilter = new RequestBuilder();
						importFilter.addSort('regDate', false);
						importFilter.addFilter({ field: 'status' }, importFilter.comparisonTypes.Equals, status);
						importFilter.fields = ['file', 'status', 'regDate', 'user', 'numRows'];
						importFilter.limit = AdminSubCtrl.rootData.pageData.limit;
						importFilter.offset = offset;

						return Import.find(importFilter.build());
					};

					AdminSubCtrl.rootData.pageData.getDone = function (offset = 0) {
						AdminSubCtrl.rootData.pageData.doneLoading = true;
						AdminSubCtrl.rootData.pageData.doneOffset = offset;
						return getImports(Import.status.FINISHED, AdminSubCtrl.rootData.pageData.doneOffset).then(
							res => {
								AdminSubCtrl.rootData.pageData.doneLoading = false;
								AdminSubCtrl.rootData.pageData.done = res.data;
								AdminSubCtrl.rootData.pageData.doneTotal = res.metadata.total;
							}
						);
					};

					AdminSubCtrl.rootData.pageData.getStarted = function (offset = 0) {
						AdminSubCtrl.rootData.pageData.startedLoading = true;
						AdminSubCtrl.rootData.pageData.startedOffset = offset;
						return getImports(
							[Import.status.START, Import.status.STARTED],
							AdminSubCtrl.rootData.pageData.startedOffset
						).then(res => {
							AdminSubCtrl.rootData.pageData.startedLoading = false;
							AdminSubCtrl.rootData.pageData.started = res.data;
							AdminSubCtrl.rootData.pageData.startedTotal = res.metadata.total;
						});
					};

					AdminSubCtrl.rootData.pageData.getDraft = function (offset = 0) {
						AdminSubCtrl.rootData.pageData.draftLoading = true;
						AdminSubCtrl.rootData.pageData.draftOffset = offset;
						return getImports(Import.status.DRAFT, AdminSubCtrl.rootData.pageData.draftOffset).then(res => {
							AdminSubCtrl.rootData.pageData.draftLoading = false;
							AdminSubCtrl.rootData.pageData.draft = res.data;
							AdminSubCtrl.rootData.pageData.draftTotal = res.metadata.total;
						});
					};

					Promise.all([
						AdminSubCtrl.rootData.pageData.getDone(0),
						AdminSubCtrl.rootData.pageData.getStarted(0),
						AdminSubCtrl.rootData.pageData.getDraft(0)
					])
						.then(() => {
							AdminSubCtrl.rootData.pageLoading = false;
						})
						.catch(e => console.log('get imports error', e));

					AdminSubCtrl.rootData.onCreate = function (file, importType) {
						AdminSubCtrl.rootData.saving = true;

						Import.upload(file, false, { type: importType })
							.then(function (importData) {
								AdminSubCtrl.rootData.pageData.draft.push(importData.data);

								AdminSubCtrl.rootData.saving = false;

								var id = importData.data.id;

								if (Tools.FeatureHelper.hasSoftDeployAccess('REACT_IMPORT')) {
									Tools.routerHistory.push('/admin/import/' + id, {
										isNew: true,
										stepId: Tools.$state.params.stepId
									});
								} else {
									Tools.$state.go('administration.import', {
										id: id,
										stepId: Tools.$state.params.stepId,
										isNew: true
									});
								}
							})
							.catch(function (response) {
								NotificationService.addNotification({
									style: Tools.NotificationService.style.ERROR,
									title: 'default.error',
									body: response?.error?.translated ?? 'file.uploadFailed',
									icon: 'times'
								});
								AdminSubCtrl.rootData.saving = false;
							});
					};

					AdminSubCtrl.rootData.deleteImport = function (imprt) {
						openModal('RemoveAlert', {
							title: 'import.import',
							body: 'confirm.removeImport',
							onClose: confirmed => {
								if (confirmed) {
									Import.delete(imprt)
										.then(function () {
											var index = _.findIndex(AdminSubCtrl.rootData.pageData.draft, {
												id: imprt.id
											});
											AdminSubCtrl.rootData.pageData.draft.splice(index, 1);
										})
										.catch(e => console.log('delete import error', e));
								}
							}
						});
					};

					$scope.$on('pushNotification.data', function (e, data) {
						if (data && data.type === 'Import') {
							var i = _.findIndex(AdminSubCtrl.rootData.pageData.ongoing, { id: data.id });
							if (i !== -1) {
								// Update status
								AdminSubCtrl.rootData.pageData.ongoing[i].status = data.status;
							} else if (data.status !== 100 && data.status !== -1) {
								AdminSubCtrl.rootData.pageData.ongoing.push(data);
							}

							if (data.status === 100) {
								if (i !== -1) {
									AdminSubCtrl.rootData.pageData.ongoing.splice(i, 1);
								}
								getImports();
							}

							$safeApply($scope);
						}
					});

					// Check for ongoing imports
					var notiFilter = new Tools.RequestBuilder();
					notiFilter.addFilter({ field: 'type' }, notiFilter.comparisonTypes.Equals, 'Import');
					notiFilter.addFilter({ field: 'status' }, notiFilter.comparisonTypes.NotEquals, '100');
					notiFilter.addFilter({ field: 'status' }, notiFilter.comparisonTypes.NotEquals, '-1');
					Tools.PushNotifications.customer(AppService.getCustomerId())
						.find(notiFilter.build())
						.then(function (res) {
							AdminSubCtrl.rootData.pageData.ongoing = res.data;
						})
						.catch(e => console.log('find notification error', e));

					break;
				case 'administration.singleuser':
					component = 'singleuser';
					break;

				default:
					component = 'notFound';
					break;
			}

			AdminSubCtrl.rootData.pageComponent = component;
			AdminSubCtrl.rootData.useWebPack = useWebPack;
		};

		AppService.loadedPromise.then(init).catch(e => console.log('admin load error', e));
	}
]);
